import { Empty, Popover } from 'antd'

import { QuotaEntity } from '@eastcoal/api/trade/interface'

import { ListQuotas } from './Quotas'

export const QuotaPopover = ({ quotas }: { quotas: QuotaEntity[] }) => {
  const popoverContentRender = quotas?.length ? (
    <ListQuotas quotas={quotas} />
  ) : (
    <Empty />
  )

  return (
    <Popover
      content={popoverContentRender}
      placement='bottomLeft'
      trigger='hover'
      styles={{
        container: {
          padding: 0
        }
      }}
    >
      <span style={{ color: '#1890FF' }}>查看</span>
    </Popover>
  )
}
